import type { StepsProps as AntStepsProps } from "antd";
import { Steps as AntSteps } from "antd";
import React from "react";
export interface Step {
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  status?: "wait" | "process" | "finish" | "error";
  disabled?: boolean;
}
export interface StepsProps extends Omit<AntStepsProps, "items"> {
  items: Step[];
}
const Steps: React.FC<StepsProps> = ({ items, ...props }) => (
  <AntSteps {...props}>
    {items.map((item, index) => (
      <AntSteps.Step key={index} {...item} />
    ))}
  </AntSteps>
);
export default Steps;
